import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import { useProfile } from "../contexts/ProfileContext";
// import CorporateRegistrationModel from "./CorporateRegistrationModel";

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // const [showModal, setShowModal] = useState(false);
  const [decodedToken, setDecodedToken] = useState(null);
  const { fetchCorporateProfileStatus } = useProfile();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    const newUser = params.get("newUser");
    const decoded = jwtDecode(token);
    setDecodedToken(decoded);
    console.log("Decoded token:", decoded);
    // if (newUser === "true" && decoded.userType === "corporate") {
    //   setShowModal(true);
    //   Cookies.set("tempToken", token, {
    //     expires: 7,
    //     secure: true,
    //     sameSite: "Strict",
    //   });
    //   return;
    // }
    if (token) {
      Cookies.set("token", token, {
        expires: 7,
        secure: true,
        sameSite: "Strict",
      });

      redirectUser(decoded);
    } else {
      navigate(`/login?tab=${decoded.userType}`);
    }
  }, [navigate, location]);

  const redirectUser = async (decoded) => {
    if (decoded.userType === "corporate") {
      // Fetch corporate profile status before redirecting
      const requiresProfile = await fetchCorporateProfileStatus();
      if (requiresProfile === false) {
        navigate("/corporate/interviews");
      } else {
        navigate("/corporate/profile");
      }
    } else {
      navigate("/candidate");
    }
  };

  // const handleModalSubmit = async (formData) => {
  //   try {
  //     const token = Cookies.get("tempToken");

  //     const response = await fetch(
  //       `${process.env.REACT_APP_API_URL}/api/corporate/profile/`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`, // send JWT token
  //         },
  //         body: JSON.stringify(formData),
  //       }
  //     );

  //     if (!response.ok) {
  //       throw new Error("Failed to save company profile");
  //     }

  //     const data = await response.json();
  //     console.log("✅ Profile saved:", data);

  //     // after success:
  //     setShowModal(false);

  //     Cookies.remove("tempToken");
  //     navigate("/login?tab=corporate");
  //   } catch (error) {
  //     console.error("❌ Error saving profile:", error);
  //     alert("Something went wrong while saving company profile.");
  //   }
  // };

  // if (showModal) {
  //   return (
  //     <CorporateRegistrationModel open={true} onSubmit={handleModalSubmit} />
  //   );
  // }

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
    >
      <CircularProgress />
    </Box>
  );
};

export default AuthCallback;
